import { useMemo } from 'react';

export const modalContentTypes = {
  invoiceAndTypes: 'invoiceAndTypes',
  typesAndState: 'typesAndState',
};

export const useModalContentType = (entity) => {
  const contentType = useMemo(() => {
    if (!entity) return null;

    const { invoice } = entity;
    const { isFinal } = invoice || {};

    return isFinal
      ? modalContentTypes.typesAndState
      : modalContentTypes.invoiceAndTypes;
  }, [entity]);

  return contentType;
};
